import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { LoginService } from '../services/LoginService';
import { PATIENT_API } from '../ApiNames';
import { useDispatch } from 'react-redux';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import FinaceofficerLayout from '../layout/finaceofficerlayout/FinaceofficerLayout';
import useEffectOnce from '../hooks/useEffectOnce';
import { Button } from 'primereact/button';
export const AddNormalCase = () => {
  const [searchParams] = useSearchParams();
  const uid = window.sessionStorage.getItem('uid');
  const doctorid = searchParams.get('doctorid');
  const hospitalid = searchParams.get('hospitalid');
  const countryid = searchParams.get('countryid');
  const specialityid = searchParams.get('specialityid');
  const [userData, setUserData] = useState<[]>([]);
  const dispatch = useDispatch();
  const fetchSpeciality = async () => {
    try {
      const payload = { userid: uid };
      const apiname = PATIENT_API.caseCount_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [userData1, setUserData1] = useState<[]>([]);

  const fetchSickness = async () => {
    try {
      const payload = { doctorid: doctorid, q: 1 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData1(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [Sickness, setSickness] = useState('');
  const [sicknessDes, setSicknessDes] = useState('');
  const [SickID, setSickID] = useState<any>('');
  const [userData2, setUserData2] = useState<[]>([]);
  // const fetchDocDetails = async () => {
  //   try {
  //     const payload = { specialityid: specialityid, q: 2 };
  //     const apiname = PATIENT_API.detailsfee_API;
  //     const response = await LoginService.getData(apiname, payload);
  //     setUserData2(response);
  //     const SickID = response[0]?.SickID;
  //     setSickID(SickID);
  //     // if (SickID) {
  //     //   fetchSickDes(SickID);
  //     // }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
 const fetchDocDetails = async () => {
  try {
    const payload = { specialityid: specialityid, q: 2 };
    const apiname = PATIENT_API.detailsfee_API;

    const response: any[] = await LoginService.getData(apiname, payload); // 🔥 FIX

   const uniqueData = Array.from(
  new Map(
    response.map((item: any) => [
      item.Sickness?.trim().toLowerCase(), // 👈 key
      item
    ])
  ).values()
);


    setUserData2(uniqueData as []); // now TS accepts it

    const SickID = uniqueData[0]?.SickID;
    setSickID(SickID);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  useEffectOnce(() => {
    fetchSickness();
    fetchSpeciality();
    fetchDocDetails();
  }, [dispatch]);
  // console.log(SickID,"SickNESSID")
  //for panel
  const [userData3, setUserData3] = useState<[]>([]);
  const fetchSickDes = async (SickID: any) => {
    try {
      const payload = { sicknessid: SickID, q: 4 };
      const apiname = PATIENT_API.detailsfee_API;
      const response = await LoginService.getData(apiname, payload);
      setSicknessDes(response[0]?.Sicknessdesc);
      // setSickID(response[0].s)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
const navigate = useNavigate();
  const Paynew = () => {
    if (doctorid && hospitalid && countryid && specialityid && sicknessDes && SickID ) {
      const queryParams = {
        doctorid: doctorid,
        hospitalid: hospitalid,
        countryid: countryid,
        specialityid:specialityid,
        sicknessdesc:sicknessDes,
        sicknessid:SickID,

      };
      const queryString = new URLSearchParams(queryParams).toString();
      navigate(`/paypal?${queryString}`);
    }
  }



  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-6">
                    <h1 style={{ textAlign: 'start' }}>Enter Case Details</h1>
                  </div>
                </div>
              </div>
            </section>
            <section className="content">
              <div className="container-fluid">
                <div className="grid">
                  <div className="col-4">
                    {userData1.map((response: any, index: any) => (
                      <Card header="" style={{ width: '320px', marginTop: '20px' }}>
                        <div
                          className="widget-user-header bg-info"
                          style={{
                            height: '120px',
                            backgroundColor: 'rgb(23, 162, 184)',
                            display: 'flex',
                            alignItems: 'center',
                            width: '115%',
                            marginLeft: '-21px',
                            marginTop: '-40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                          }}
                        >
                          <img
                            src={response.photo}
                            alt="User Avatar"
                            style={{
                              width: '110px',
                              height: '80px',
                              borderRadius: '50%',
                              padding: '3px',
                              backgroundColor: 'rgb(23, 162, 184)',
                              marginRight: '15px',
                              color:'white',
                              marginLeft: '20px',
                              border: '3px solid #adb5bd',
                            }}
                          />
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <h2
                              className="widget-user-username"
                              style={{
                                color: 'white',
                                fontWeight: '200',
                                fontSize: '25px',
                                marginBottom: '10px',
                              }}
                            >
                              {response.FirstName}
                            </h2>
                            <h3
                              className="widget-user-username"
                              style={{
                                color: '#6c757d',
                                fontSize: '1rem',
                                margin: '0',
                                fontWeight: '400',
                              }}
                            >
                              Doctor
                            </h3>
                          </div>
                        </div>

                        {[
                          { label: 'Speciality', value: response.SpecilityName, bgColor: 'rgb(23, 162, 184)' },
                          { label: 'Country', value: response.CountryName, bgColor: 'rgb(40, 167, 69)' },
                        ].map((item, index) => (
                          <React.Fragment key={index}>
                            <div
                              className="grid"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '0px',
                              }}
                            >
                              <strong
                                style={{
                                  width: '100px',
                                  fontWeight: '500',
                                  textAlign: 'left', marginLeft: '20px',
                                  marginTop: '-5px',
                                }}
                              >
                                {item.label}
                              </strong>
                              <p
                                className="text-muted"
                                style={{
                                  backgroundColor: item.bgColor,
                                  color: 'white',
                                  borderRadius: '6px',
                                  textAlign: 'center',
                                  marginLeft: '15px',
                                  padding: '5px 10px',
                                  display: 'inline-block',
                                }}
                              >
                                {item.value}
                              </p>
                            </div>
                          </React.Fragment>
                        ))}

                      </Card>
                    ))}
                  </div>
                <div className="col-8">
                  <div>
                    <h4 style={{textAlign:'start'}}>Payment Form</h4>
                    <hr
                      style={{
                        width: '116%',
                        border: '0.5px solid rgba(0, 0, 0, 0.1)',
                        margin: '-8px 0',
                        marginLeft: '-20px'
                      }}
                    />
                  </div>
                    
                  <div className="flex align-items-center mb-3" style={{marginTop:'50px'}}>
                    <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px', }}>Sickness List:</label>
                    <Dropdown id="Sickness" value={Sickness} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchSickDes(e.value); setSickness(e.value) }} options={userData2} optionLabel="Sickness" optionValue="SickID" placeholder="Select a Sickness" style={{ flex: 1, marginLeft: '10px' }} />
                  </div>
                  <div className="flex align-items-center mb-3">
                    <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Sickness:</label>
                    <InputText id="nameoforg" type="text" placeholder="Enter Sickness" value={sicknessDes} onChange={(e) => setSicknessDes(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} />
                  </div>
                  <Button label='Submit' className='select' style={{backgroundColor:'rgb(17, 122, 139)',color:'white',border:'none'}} onClick={Paynew}/>

                </div>
                </div>
              </div >
            </section >
          </div >
        </div>
      </div>
    </div>
  )
}